import { Phone, Mail, MapPin, Instagram, Facebook, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid gap-10 md:grid-cols-4">
        <div>
          <img src="/logo.png" alt="7 Star Limo Services" className="h-20 w-auto" />
          <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
            Houston&apos;s premier luxury chauffeur service. Flat-rate airport transfers, corporate travel &amp; special events.
          </p>
          <div className="flex gap-4 mt-5 text-muted-foreground">
            <a href="#" aria-label="Instagram" className="hover:text-primary transition-colors"><Instagram size={18} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-primary transition-colors"><Facebook size={18} /></a>
            <a href="#" aria-label="Twitter" className="hover:text-primary transition-colors"><Twitter size={18} /></a>
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Quick Links</h4>
          <ul className="space-y-3 text-sm text-foreground/80">
            {["Services", "Fleet", "Pricing", "About", "Contact"].map((x) => {
              const anchor = x.toLowerCase() === "pricing" ? "routes" : x.toLowerCase() === "about" ? "why" : x.toLowerCase();
              return (
                <li key={x}><Link to={`/#${anchor}`} className="hover:text-primary transition-colors">{x}</Link></li>
              );
            })}
            <li><Link to="/blog" data-testid="footer-blog" className="hover:text-primary transition-colors">Blog</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Legal</h4>
          <ul className="space-y-3 text-sm text-foreground/80">
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
            <li><Link to="/cancellation-policy" data-testid="footer-cancellation" className="hover:text-primary transition-colors">Cancellation Policy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-foreground/80">
            <li className="flex items-center gap-2"><Phone size={15} className="text-primary" /> 979-337-9282</li>
            <li className="flex items-center gap-2"><Mail size={15} className="text-primary" /> trips.7starlimo@gmail.com</li>
            <li className="flex items-center gap-2"><MapPin size={15} className="text-primary" /> Houston, TX</li>
            <li className="text-muted-foreground">Available 24/7</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-white/10 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} 7 Star Limo Services. All rights reserved.
      </div>
    </footer>
  );
}
